<template>
  <router-view />
</template>

<script>
import router from './router';

import { useMapStore } from '@/stores/mapStore';

export default {
  name: 'App',
  data() {
    return {
      mapStore: null,
    }
  },
  components: {

  },
  mounted() {
    this.mapStore = useMapStore();
    // this.mapStore.loadCodeList();
  }
}
</script>

<style scoped>
@import url("./assets/css/app.css");
@import url("./assets/css/icon.css");
/* @import url("./assets/css/application.css"); */
</style>
